import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	// The trigger label restates the selection, so its natural width changes on every toggle. A floor keeps
	// the control from resizing under the cursor; everything else comes from the components-v2 defaults.
	trigger: {
		minWidth: 250,
	},
});
